import ChartMakeSummaryPage from './ChartMakeSummaryPage';

export default ChartMakeSummaryPage;
